export default __webpack_public_path__ + "static/media/image3.5e9bbdca.jpg";